export const getEcorregioes = (state) => state.ecorregioes.lista
export const getEcorregioesTerrestre = (state) => state.ecorregioes.listaTerreste
export const getEcorregioesMarinho = (state) => state.ecorregioes.listaMarinho
export const getIsCarregandoListaEcorregioes = (state) => state.ecorregioes.isCarregandoLista
export const getIsSavingEcorregioes = (state) => state.ecorregioes.isSaving
export const getIsUpdatingEcorregioes = (state) => state.ecorregioes.isUpdate
